//
//
//
//
//
//

export default {
  name: 'group-title'
}



// WEBPACK FOOTER //
// ./~/vux/src/components/group-title/index.vue